import React, { useContext, useEffect, useMemo, useState } from 'react'
import { ThemeContext } from '../../../../../auth';
import Swal from 'sweetalert2';
import { Button, Form, Modal, Spinner } from 'react-bootstrap';
import { Formik } from 'formik';
import Select from 'react-select';
import { BsEyeFill, BsEyeSlashFill } from 'react-icons/bs';
import { axiosAuth } from '../../../../../api';


function ModalUbahAkunPegawai({
    rowSelected,
    showEditPegawai,
    setShowEditPegawai,
    retrieveAkun,
    accessToken,
    listDivisi,
}) {
    const { theme } = useContext(ThemeContext);
    const [listRole, setListRole] = useState([]);
    const [disabled, setDisabled] = useState(false);
    const [selectedDivisi, setSelectedDivisi] = useState(null);
    const [selectedRole, setSelectedRole] = useState(null);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const [password, setPwd] = useState('');

    const [passwordShown, setPasswordShown] = useState(false);
    const togglePassword = () => {
        setPasswordShown(!passwordShown);
    };

    const [error, setError] = useState('');

    const [isActive, setIsActive] = useState(rowSelected?.isActive || true);

    useEffect(() => {
        if (rowSelected && rowSelected.isActive !== undefined) {
            setIsActive(rowSelected.isActive);
        }

    }, [rowSelected]);

    const defaultValue = {
        firstName: rowSelected?.firstName || "",
        lastName: rowSelected?.lastName || "",
        email: rowSelected?.email || "",
        username: rowSelected?.username || "",
        roleId: rowSelected?.role.id || "",
        roleName: rowSelected?.role.roleName || "",
        groupId: rowSelected?.role.group.id || "",
        groupName: rowSelected?.role.group.groupName || "",
        position: rowSelected?.position || "",
    };

    const divisiOptions = useMemo(() =>
        listDivisi.map(divisi => ({
            value: divisi.id,
            label: divisi.groupName,
        })), [listDivisi]);

    const handleSelectDivisi = (selectedOption, setFieldValue) => {
        setSelectedDivisi(selectedOption);
        setSelectedRole(null);
        setFieldValue('role.id', null);
        setFieldValue('role.group.id', selectedOption ? selectedOption.value : null);
    };

    useEffect(() => {
        if (showEditPegawai && !selectedDivisi) {
            const defaultSelected = divisiOptions.find(
                option => option.value === rowSelected?.role.group.id
            );
            setSelectedDivisi(defaultSelected || null);
        }
    }, [showEditPegawai, rowSelected, divisiOptions]);

    const roleOptions = useMemo(() =>
        listRole.map(role => ({
            value: role.id,
            label: role.roleName,
        })), [listRole]);

    const handleSelectRole = (selectedOption, setFieldValue) => {
        setSelectedRole(selectedOption);
        setFieldValue('role.id', selectedOption ? selectedOption.value : null);
    };

    useEffect(() => {
        if (showEditPegawai && !selectedRole) {
            const defaultSelected = roleOptions.find(
                option => option.value === rowSelected?.role.id
            );
            setSelectedRole(defaultSelected || null);
        }
    }, [showEditPegawai, rowSelected, roleOptions]);

    const retrieveRole = () => {
        if (!selectedDivisi?.value) return;

        axiosAuth.get(`/api/roles?groupId=${selectedDivisi.value}`, {
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                withCredentials: true,
                Authorization: `Bearer ${accessToken}`,
            },

        })
            .then(res => {
                setListRole(res.data.data || []);
            })
            .catch(err => {
                console.error(err);
            });
    };

    useEffect(() => {
        if (selectedDivisi?.value !== undefined) retrieveRole();
    }, [selectedDivisi?.value]);

    const handleClose = () => {
        setShowEditPegawai(false);
        setSelectedDivisi(null);
        setSelectedRole(null);
        setPwd('');
    };

    const formStyles = {
        label: {
            fontFamily: 'Poppins-Medium',
            color: theme === 'light' ? '#FFFFFF' : '#222222',
        },
        input: {
            color: theme === 'light' ? '#FFFFFF' : '#222222',
            backgroundColor: theme === 'light' ? '#212529' : '#FFFFFF',
            fontFamily: 'Poppins-Regular',
            minHeight: '50px',
            borderColor: '#ced4da',
        },
    };


    const selectStyles = {
        control: (provided, state) => ({
            ...provided,
            minHeight: '50px',
            border: state.isFocused ? '1px solid #80bdff' : '1px solid #ced4da',
            boxShadow: state.isFocused ? '0 0 0 0.3rem rgba(0, 123, 255, 0.25)' : null,
            '&:hover': {
                borderColor: '#80bdff',
            },
            textAlign: 'left',
            fontFamily: 'Poppins-Regular',
            borderTopRightRadius: '0px',
            borderBottomRightRadius: '0px',
            background: theme === 'light' ? '#212529' : '#FFFFFF',
        }),
        option: (provided, state) => ({
            ...provided,
            color: state.isSelected ? '#fff' : '#333',
            background: state.isSelected ? '#007bff' : '#fff',
            fontFamily: 'Poppins-Regular',
            textAlign: 'left'
        }),
        singleValue: (provided, state) => ({
            ...provided,
            color: theme === 'light' ? '#FFFFFF' : '#222',
            fontFamily: 'Poppins-Regular',
        })

    };

    const handleSubmitEdit = async (values) => {

        const finalData = {
            ...values,
            roleId: selectedRole?.value,
            isActive: isActive,
        };

        const finalDataWithPassword = {
            ...values,
            roleId: selectedRole?.value,
            password: password,
            isActive: isActive,
        };

        setIsSubmitting(true);
        setDisabled(true);

        try {

            const response = await axiosAuth.put(`/api/users/${rowSelected?.id}`,
                !password ? finalData : finalDataWithPassword, {
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                    withCredentials: true,
                    Authorization: `Bearer ${accessToken}`,
                },
            });

            Swal.fire({
                icon: 'success',
                title: 'Berhasil mengubah Pegawai',
                showConfirmButton: true,
            });

            handleClose();
            retrieveAkun();
            setIsSubmitting(false);
            setDisabled(false);

        } catch (err) {

            console.error(err);
            if (err.response?.status === 400) {
                Swal.fire({
                    icon: 'error',
                    title: 'Oops...!',
                    text: `${err.response?.data.message}`,
                })
                setIsSubmitting(false);
                setDisabled(false);
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: 'Terjadi kesalahan saat menambahkan Pegawai',
                });
                setIsSubmitting(false);
                setDisabled(false);
            }
        } finally {
            setIsSubmitting(false);
            setDisabled(false);
        }
    };

    return (
        <Modal
            show={showEditPegawai}
            onHide={handleClose}
            backdrop="static"
            keyboard={false}
            centered
            data-bs-theme={theme === 'light' ? 'dark' : ''}
        >
            <Modal.Header closeButton >
                <Modal.Title style={{ fontFamily: 'Poppins-Medium', color: theme === 'light' ? '#FFFFFF' : '#222222' }}>
                    Ubah Akun Pegawai
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Formik
                    initialValues={defaultValue}
                    enableReinitialize={true}
                    onSubmit={handleSubmitEdit}
                >
                    {({
                        handleSubmit,
                        handleChange,
                        values,
                        setFieldValue,
                    }) => (
                        <Form onSubmit={handleSubmit}>
                            <Form.Group className="mb-3">
                                <Form.Label style={formStyles.label}>Aktif</Form.Label>
                                <Form.Check
                                    type='checkbox'
                                    id='default-checkbox'
                                    onChange={(e) => setIsActive(e.target.checked)}
                                    checked={isActive}
                                    style={formStyles.label}
                                />
                            </Form.Group>
                            <Form.Group className="mb-3">
                                <Form.Label style={formStyles.label} htmlFor='firstName'>Nama Depan*</Form.Label>
                                <Form.Control
                                    id='firstName'
                                    type="text"
                                    disabled={disabled}
                                    value={values.firstName}
                                    onChange={handleChange("firstName")}
                                    required
                                    style={formStyles.input}
                                />
                            </Form.Group>
                            <Form.Group className="mb-3">
                                <Form.Label style={formStyles.label} htmlFor='lastName'>Nama Belakang</Form.Label>
                                <Form.Control
                                    id='lastName'
                                    type="text"
                                    disabled={disabled}
                                    value={values.lastName}
                                    onChange={handleChange("lastName")}
                                    // required
                                    style={formStyles.input}
                                />
                            </Form.Group>
                            <Form.Group className="mb-3">
                                <Form.Label style={formStyles.label} htmlFor='email'>Email*</Form.Label>
                                <Form.Control
                                    id='email'
                                    type="email"
                                    disabled={disabled}
                                    value={values.email}
                                    onChange={handleChange("email")}
                                    required
                                    style={formStyles.input}
                                />
                            </Form.Group>
                            <Form.Group className="mb-3">
                                <Form.Label style={formStyles.label} htmlFor='divisi'>Divisi*</Form.Label>
                                <Select
                                    id='divisi'
                                    options={divisiOptions}
                                    required
                                    value={selectedDivisi || null}
                                    onChange={option => handleSelectDivisi(option, setFieldValue)}
                                    styles={selectStyles}
                                    placeholder='Pilih Divisi'
                                />
                            </Form.Group>
                            <Form.Group className="mb-3">
                                <Form.Label style={formStyles.label} htmlFor='role'>Role*</Form.Label>
                                <Select
                                    id="role"
                                    options={roleOptions}
                                    required
                                    value={selectedRole || null}
                                    onChange={(option) => handleSelectRole(option, setFieldValue)}
                                    styles={selectStyles}
                                    placeholder="Pilih Role"
                                />
                            </Form.Group>
                            <Form.Group className="mb-3">
                                <Form.Label style={formStyles.label} htmlFor='position'>Posisi*</Form.Label>
                                <Form.Control
                                    id='position'
                                    type="text"
                                    disabled={disabled}
                                    value={values.position || ''}
                                    onChange={handleChange("position")}
                                    required
                                    style={formStyles.input}
                                />
                            </Form.Group>
                            <Form.Group className="mb-3" >
                                <Form.Label style={formStyles.label} htmlFor='passwordLogin'>Password</Form.Label>
                                <Form.Control
                                    id='password'
                                    type={passwordShown ? "text" : "password"}
                                    disabled={disabled}
                                    onChange={(e) => setPwd(e.target.value)}
                                    value={password}
                                    placeholder='Change password'
                                    style={formStyles.input}
                                />
                                <p className='mt-2' onClick={togglePassword} style={{ fontFamily: 'Poppins-Regular', cursor: 'pointer', maxWidth: '170px', color: theme === 'light' ? '#FFFFFF' : '#222222' }}>{passwordShown ? "Hide" : "Show"} password <span >{passwordShown ? <BsEyeSlashFill size={20} /> : <BsEyeFill size={20} />} </span></p>
                            </Form.Group>
                            <div className="d-grid gap-2 mt-4">
                                {isSubmitting ? (
                                    <Button
                                        id={theme === 'light' ? 'actionButtonModalDark' : 'actionButtonModalLight'}
                                        variant='btn'
                                        disabled
                                    >
                                        <Spinner
                                            animation="border"
                                            size='sm'
                                        />
                                    </Button>
                                ) : (
                                    <Button
                                        type="submit"
                                        id={theme === 'light' ? 'actionButtonModalDark' : 'actionButtonModalLight'}
                                        variant='btn'
                                        disabled={disabled}
                                    >
                                        Simpan
                                    </Button>
                                )}
                            </div>
                        </Form>
                    )}
                </Formik>
            </Modal.Body>
        </Modal>
    )
}

export default ModalUbahAkunPegawai
